import { ControlNetModelsType } from '../constants/enums/ControlNetModelsType.ts';

export const controlNetModelsConfig = {
	[ControlNetModelsType.SD15]: {
		base_model: 'SD 1.5',
		id: 'ctl_uJmPBGq3bM',
		image_url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/controlnet/depth.webp`,
		model: 'control_v11f1p_sd15_depth [cfd03158]',
		module: 'depth_midas',
		name: 'Depth',
		popularity: 1,
	},
	[ControlNetModelsType.SDXL]: {
		base_model: 'SDXL',
		id: 'ctl_cndvEH2iSh',
		image_url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/controlnet/depth.webp`,
		model: 'diffusers_xl_depth_full [2f51180b]',
		module: 'depth_midas',
		name: 'Depth',
		popularity: 1,
	},
	[ControlNetModelsType.Flux]: {
		base_model: 'flux',
		id: 'ctl_LEpGhMqsqZ',
		image_url: 'https://redernet-image-data.s3.amazonaws.com/prod/assets/controlnet/depth.webp',
		model: 'flux1-depth-dev.safetensors',
		module: 'depth_midas',
		name: 'Depth',
		popularity: 0,
	},
};
